export const ROUTE_DASHBOARD = "/role-based-code/dashboard";
export const ROUTE_CHAT = "/role-based-code/chat";
export const ROUTE_QUIZ = "/role-based-code/quiz";
export const ROUTE_LOGIN = "/";
export const ROUTE_SIGN_UP = "/role-based-code/sign-up";
export const ROUTE_AI_GENERATE = "/role-based-code/ai-generate";
export const ROUTE_DESCRIPTIVE = "/role-based-code/descriptive";
export const ROUTE_AI_ANALYSIS = "/role-based-code/analysis";
export const ROUTE_PROFILE = "/role-based-code/profile";
export const ROUTE_PAYMENT_SUCCESS = "/role-based-code/payment-success";
// Admin App Routes (root level routes for admin app)
export const ROUTE_STUDENT_MANAGEMENT = "/role-based-code/student-management";
export const ROUTE_SCHOOL_MANAGEMENT = "/role-based-code/school-managament";
export const ROUTE_LEARNING_ASSETS = "/role-based-code/learning-assets";
export const ROUTE_MOCK_TEST = "/role-based-code/mock-test";
export const ROUTE_INTERVIEW = "/role-based-code/upsc-interview";
export const routeToMCQ = (subject) =>
  `/role-based-code/${ROUTE_QUIZ}?subject=${subject}`;
export const ROUTE_COMPETITIVE_EXAM = "/role-based-code/competitive-exam";
export const routeEvalutionToQuiz = (subject, chapter) =>
  `${ROUTE_QUIZ}?subject=${subject}&chapter=${chapter}`;
export const routeEvalutionTnspscToQuiz = (
  medium,
  part,
  unit,
  chapter,
  lesson,
) =>
  `${ROUTE_QUIZ}?medium=${medium}&part=${part}&unit=${unit}&chapter=${chapter}&lesson=${lesson}`;
